import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import plumber from "../../Assets/Projects/Plumber.mama.png";
import shop from "../../Assets/Projects/red.onion.png";
import editor from "../../Assets/Projects/java.png";
import ride from "../../Assets/Projects/1619432259405.png";
import mart from "../../Assets/Projects/super.mart.png";
import league from "../../Assets/Projects/English.png";
import ema from "../../Assets/Projects/ema-jhon.png";
import react from "../../Assets/Projects/React.png";
import node from "../../Assets/Projects/How-Node.JS-Works.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
         <strong className="purple"> PROJECTS I HAVE BUILT </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shop}
              isBlog={false}
              title="Red-Onion"
              description="A Single page E-commerce app where people are able to choice 3 category foods,order several
               items and check out order review their order,use customer online pay and visit the blog Post ##Deployment is pending "
              link="https://github.com/nishat-1998/Red-Onion"
              code="https://github.com/nishat-1998/Red-Onion"
            />
          </Col>
         
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={plumber}
              isBlog={false}
              title="Plumber Mama"
              description="This is MERN Project and Using CRUD Operation.It's a Dynamic Web Application Customer Add Review .## Front-end Technology:React.js,Es-6,Bootstrap5, CSS3
               ##Backend Technology:Node.js,Express.js,MongoDB,Firebase Authentication,Stripe.js" 
              link="https://plumber-bd.web.app/"
              code="https://github.com/nishat-1998/PLUMBER-MAMA-CLIENT"
            />
      </Col>
      <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ema}
              isBlog={false}
              title="Ema-Jhon"
              description="MERN Projects A Single page E-commerce app where people are able to buy their products.##Front-end Technology:React.js,Es-6,ReactBootStarp,contextApiReact-hook,Bootstrap5,CSS3
              ##Backend Technology:Node.js,Express.js,MongoDB,Firebase Authentication,Stripe.js "
              link="https://fire-auth-recap-5ca96.web.app/"
              code="https://github.com/nishat-1998/ema-jhon-full-stack-client"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mart}
              isBlog={false}
              title="Super Mart"
              description="A Single page E-commerce MERN APP and## Front-end Technology:React.js,Es-6,ContextApi,Material Ui, CSS3 ##Backend Technology:Node.js,Express.js,MongoDB,Firebase Authentication"
              link="https://super-mart-bd.web.app/"
              code="https://github.com/nishat-1998/Super-Mart-Client"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ride}
              isBlog={false}
              title="Pick Me"
              description=" People are able to select vehicles in their book button and more with their information to the navbar.
              Front-end Technology:React.js,javaScript,MaterialUi,ReactBootstrap,React-hook,Google Map,html,CSS3,Firebase Authentication .."
              link="https://as-fire-auth.web.app/"
              code="https://github.com/nishat-1998/PICK-ME"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={league}
              isBlog={false}
              title="API-Premier-League"
              description="This is English premier leauge 2021 Website and Rest API using this Projects.
              Technology:javaScript,ReactBootstrap,html5,CSS3,BootStrap"
              link="https://modest-lovelace-7df389.netlify.app/"
              code="https://github.com/nishat-1998/Premier-League"
              
            />
          </Col>

        </Row>
        <h1 className="project-heading">
          My Recent <strong className="purple">Blog </strong> Posts
        </h1>
        <p style={{ color: "white" }}>Do give a read to some of my blogs</p>
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={editor}
              link="coming soon"
              title="javaScript"
              site="Coming Soon"
            />
          </Col>
          <Col md={4} className="blog-card"> 
            <BlogCard
              imgPath={react}
              link="coming soon"
              title="React.js"
              site="coming soon"
            />
          </Col>
          <Col md={4} className="blog-card"> 
            <BlogCard
              imgPath={node}
              link="coming soon"
              title="How To Work Node.js"
              site="coming soon"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
